import React from 'react';

export default class  Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">TWO FACTOR THEORY OF MOTIVATION</span>
                                            </div>
                                            <p>Most of us know what it’s like to lack energy, be bored or
                                                unmotivated. We don’t want to get out of bed and off to work, or
                                                we’re unenthused by whatever it is we’re supposed to be doing.
                                                Even so, we all prefer to feel energised, motivated and engaged,
                                                knowing it improves our performance. So, we’ll explain how to
                                                boost your level of energy, and that of those around you,
                                                too.</p>
                                            <div className="border_subtitle">Background</div>
                                            <p>Early research into motivation<a className="superscripttext"
                                                                                href="further_info.php?course=300"><sup>2</sup></a> (Herzberg,
                                                1966) suggested there are two principles associated with
                                                motivation or the lack of it. The study investigated when and
                                                why people at work felt either positive or negative, and this
                                                led to much discussion of ‘hygiene and motivation factors’.</p>
                                            <p><span className="subtiltereg">Hygiene factors</span> refer to
                                                (external) conditions that enhance our experience or which we
                                                consider pleasant or satisfying. They don’t, in themselves, lead
                                                to increased motivation but their absence may de-motivate. For
                                                example, feeling underpaid is likely to dissatisfy or
                                                de-motivate.</p>
                                            <p><span className="subtiltereg">Motivation factors</span> differ
                                                from hygiene factors and are necessary to encourage or boost us
                                                to perform at signifi cantly higher levels. They’re what provide
                                                job satisfaction and can spur us to increased effort and
                                                performance. So, even though you may now be paid adequately,
                                                you’re not necessarily motivated. For that, you need to feel
                                                you’re achieving something.</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/raise-energy.jpg')}
                                                    className="" style={{width:'100%'}}/>
                                            </div>
                                            <p>For more information on motivation, see the ‘How to motivate
                                                others’ tool.</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Different combinations of
                                                    hygiene and motivation factors produce different results:
                                                </div>
                                                <p><span
                                                    className="subtiltereg">Low Hygiene + Low Motivation</span> =
                                                    The worst situation of all – de-motivated employees with
                                                    lots to complain about.</p>
                                                <p><span
                                                    className="subtiltereg">Low Hygiene + High Motivation</span> =
                                                    Employees are motivated but still complain a lot. It could
                                                    be that work is interesting or exciting but conditions or
                                                    salary is poor.</p>
                                                <p><span
                                                    className="subtiltereg">High Hygiene + Low Motivation</span> =
                                                    Employees don’t complain much but aren’t really motivated –
                                                    they may see their job as no more than a means of getting
                                                    paid.</p>
                                                <p><span
                                                    className="subtiltereg">High Hygiene + High Motivation</span> =
                                                    The ideal situation. Employees are highly motivated with few
                                                    complaints.</p>

                                            </div>
                                            <div className="paraspace"><p>The kind of hygiene factors which can
                                                cause dissatisfaction if employees feel they’re inadequate,
                                                include:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>Company policy and administration</li>
                                                <li>Wages, salaries and other financial remuneration</li>
                                                <li>Quality of supervision</li>
                                                <li>Quality of interpersonal relations</li>
                                            </ul>
                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page1')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page3')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}